// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.AreasHorizontaly {
  display: grid;
  grid-template-rows: 1fr fit-content(0%) 1fr fit-content(0%);
  grid-template-columns: 25% 25% 25% 25%;
}
 
.AreasVerticaly {
  display: grid;
  grid-template-rows: 200px 1fr 100px;
  grid-template-columns: 25% 25% 25% 25%;
}*/
`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/multidimensional/heterogenArea.control.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE","sourcesContent":["/*.AreasHorizontaly {\n  display: grid;\n  grid-template-rows: 1fr fit-content(0%) 1fr fit-content(0%);\n  grid-template-columns: 25% 25% 25% 25%;\n}\n \n.AreasVerticaly {\n  display: grid;\n  grid-template-rows: 200px 1fr 100px;\n  grid-template-columns: 25% 25% 25% 25%;\n}*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
